import { render, staticRenderFns } from "./FilterStock.vue?vue&type=template&id=543879f4&scoped=true"
import script from "./FilterStock.vue?vue&type=script&lang=js"
export * from "./FilterStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543879f4",
  null
  
)

export default component.exports